<template>
    <div>
        <div>
            <h4>
                <span>상태: </span>
                <span v-if="logOn">로그인 상태입니다</span>
                <span v-if="logOff">로그아웃 상태입니다</span>
            </h4>
        </div>
        
        <div class="mt-2">
            <span>보유포인트: {{ me?.point?.format?.() || 0 }}원</span>
        </div>

        <div class="mt-2">
            <v-btn color="primary" @click="init()">
                <v-icon left size="20">mdi-refresh</v-icon>
                새로고침
            </v-btn>
        </div>
    </div>
</template>

<script>
import api from "@/api";
export default {
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            await this.$store.dispatch("getUser");
        }
    },
    computed: {
        me(){ return this.$store.state.user; },
        logOn(){ return !!this.$store.state.accessToken; },
        logOff(){ return !this.$store.state.accessToken; },
    }
}
</script>